import { useState } from 'react'
import { toast } from 'react-toastify'

import { bodyPartsApi } from '../api/services/body_parts'
import { BodyPart } from '../api/services/body_parts/types.ts'
import {
  BodyMeasurement,
  BodyPartMeasurements,
  FlatBodyMeasurement
} from '../api/services/dd_panel_body_measurements/types.ts'
import { FetchResponse } from '../api/services/user_assignment_codes/types.ts'

export const useBodyParts = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [bodyParts, setBodyParts] = useState<BodyPart[] | null>(null)
  const [flatMeasurementBodyPartsArray, setFlatMeasurementBodyPartsArray] =
    useState<FlatBodyMeasurement[]>([])
  const [error, setError] = useState<string | null>(null)

  const getBodyParts = async () => {
    try {
      setLoading(true)
      const response: FetchResponse<BodyPart[]> =
        await bodyPartsApi.getList<BodyPart[]>()

      if (response.status === 200 && response.data) {
        setBodyParts(response.data)
        return response.data
      }
      if (response.status !== 200)
        setError(response.error ?? 'Something went wrong')
      return null
    } catch (error) {
      toast.error(error as string)
      return null
    } finally {
      setLoading(false)
    }
  }

  const flatMeasurementBodyParts = (
    measurements: BodyPartMeasurements[],
    parts: FlatBodyMeasurement[],
    measuredAt: string,
    createdByDietitian: boolean
  ): FlatBodyMeasurement[] => {
    const partsWithMetadata = parts.map((part) => ({
      ...part,
      measured_at: measuredAt,
      created_by_dietitian: createdByDietitian
    }))

    return measurements.reduce<FlatBodyMeasurement[]>(
      (updatedParts, measurement) => {
        const bodyPartKey = `body_part_${measurement.body_part}`

        return updatedParts.map((part) => ({
          ...part,
          [bodyPartKey]: measurement.measured_value
        }))
      },
      partsWithMetadata
    )
  }

  const flatBodyParts = (input: BodyPart[]): FlatBodyMeasurement => {
    return input.reduce<Record<string, string | boolean | number>>(
      (acc, { id }) => {
        acc[`body_part_${id}`] = '-'
        return acc
      },
      { measured_at: '', created_by_dietitian: false }
    ) as FlatBodyMeasurement
  }

  const prepareFlatMeasurementParts = async (
    bodyMeasurements: BodyMeasurement[] | null
  ) => {
    try {
      const bodyPartsL = bodyParts ? bodyParts : await getBodyParts()
      const flatParts = flatBodyParts(bodyPartsL as BodyPart[])

      const newFlatMeasurementBodyParts: FlatBodyMeasurement[] = []

      if (bodyMeasurements !== null) {
        bodyMeasurements.map((_, index) => {
          const xx = flatMeasurementBodyParts(
            bodyMeasurements[index].body_part_measurements,
            [flatParts],
            bodyMeasurements[index].measured_at,
            bodyMeasurements[index].created_by_dietitian
          )
          newFlatMeasurementBodyParts.push(xx[0])
        })
      }
      setFlatMeasurementBodyPartsArray(newFlatMeasurementBodyParts)
    } catch (error) {
      console.error('Error fetching body parts:', error)
      return []
    }
  }

  return {
    loading,
    error,
    bodyParts,
    getBodyParts,
    flatBodyParts,
    flatMeasurementBodyParts,
    prepareFlatMeasurementParts,
    flatMeasurementBodyPartsArray
  }
}
